import {
  IonCard,
  IonCol,
  IonContent,
  IonGrid,
  IonItem,
  IonLabel,
  IonRow,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import HeaderComponent from "../components/HeaderComponent";
import {
  collection,
  query,
  limit,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import ImgValueComponent from "../components/ImgValueComponent";
import { db } from "../firebaseConfig";
import {
  batteryFullOutline,
  heartOutline,
  pulseOutline,
  flagOutline,
  warningOutline,
  pinOutline,
  timerOutline,
  speedometerOutline,
} from "ionicons/icons";
import { Bar as BarChartJS } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import TimeSeriesGraph from "../components/TimeSeriesGraph";
import AlarmsComponent from "./AlarmsComponent";

const DeviceDetails: React.FC = () => {
  const location = useLocation();
  const [showPage, setShowPage] = useState(1);
  const [deviceData, setDeviceData] = useState<any>({});
  const [packCVLabels, setPackCVLabels] = useState<any>([]);
  const [packCVValues, setPackCVValues] = useState<any>([]);
  const [packTempLabels, setPackTempLabels] = useState<any>([]);
  const [packTempValues, setPackTempValues] = useState<any>([]);
  const devDetailsmountedRef = useRef(true);
  let unsubscribe: any;
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  useEffect(() => {
    if (devDetailsmountedRef.current) {
      (async () => {
        // console.log("Loaded DeviceDetails Page!");
        let packCVs: any = [],
          packCVLabelsTemp: any = [];
        let packTemps: any = [],
          packTempLabelsTemp: any = [];
        let mac = location.search.substring(7);
        console.log("deviceData: " + JSON.stringify(deviceData));
        loadSubpage(0);
        if (location.state !== undefined) {
          setDeviceData(location.state);
        }
        try {
          unsubscribe = await onSnapshot(
            query(
              collection(db, "teltonikaConnector/" + mac + "/telemetry/"),
              orderBy("timeStamp", "desc"),
              limit(1)
            ),
            (querySnapshot) => {
              querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                if (devDetailsmountedRef.current) {
                  console.log(doc.id, " => ", JSON.stringify(doc.data()));
                  console.log(
                    "devDetailsmountedRef.current: " +
                      devDetailsmountedRef.current
                  );
                  let result: any = doc.data();
                  setDeviceData({ ...result });
                  for (let i = 0; i <= 23; i++) {
                    packCVLabelsTemp[i] = "CV" + (i + 1);
                    packCVs[i] = result["CV" + (i + 1)];
                  }
                  for (let i = 0; i <= 9; i++) {
                    packTempLabelsTemp[i] = "Temp" + (i + 1);
                    packTemps[i] = result["temp" + (i + 1)];
                  }
                  setPackCVValues(packCVs);
                  setPackCVLabels(packCVLabelsTemp);
                  setPackTempValues(packTemps);
                  setPackTempLabels(packTempLabelsTemp);
                }
              });
            }
          );
        } catch (error) {
          console.log("Unknown error while fetchDataFireStore: " + error);
        }
        // console.log("PackCVLabels: " + packCVLabels);
        // console.log("PackCVs: " + packCVValues);
        // console.log("PackTempLabels: " + packTempLabels);
        // console.log("PackTemps: " + packTempValues);
        // console.log(location.pathname); // result: '/secondpage'
        // console.log(location.search); // result: '?query=abc'
        // console.log(location.state); // result: 'row'
      })();
    }
    return () => {
      devDetailsmountedRef.current = false; // clean up function
      unsubscribe = null;
    };
  }, []);

  const packCVdata = {
    labels: packCVLabels,
    datasets: [
      {
        label: "Cell Voltages (mV)",
        data: packCVValues,
        backgroundColor: "#39b54a",
      },
    ],
  };
  const packTempdata = {
    labels: packTempLabels,
    datasets: [
      {
        label: "Temperature Readings (°C)",
        data: packTempValues,
        backgroundColor: "#ffc409",
      },
    ],
  };

  function loadSubpage(num: any) {
    switch (parseInt(num)) {
      case 0: {
        // console.log("load Home page");
        setShowPage(1);
        break;
      }
      case 1: {
        // console.log("load Analytics page");
        setShowPage(2);
        break;
      }
      case 2: {
        // console.log("load Alerts page");
        setShowPage(3);
        break;
      }
    }
  }
  return (
    <IonContent fullscreen>
      <HeaderComponent title={"Device Details"} />
      <IonSegment mode="md">
        <IonSegmentButton
          className="customButton"
          onClick={() => loadSubpage(0)}
        >
          <IonLabel>Overview</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton
          className="customButton"
          onClick={() => loadSubpage(1)}
        >
          <IonLabel>Analytics</IonLabel>
        </IonSegmentButton>
        <IonSegmentButton
          className="customButton"
          onClick={() => loadSubpage(2)}
        >
          <IonLabel>Alerts</IonLabel>
        </IonSegmentButton>
      </IonSegment>
      <IonCard className="ion-no-padding">
        <IonItem>
          <img alt="document" src="./assets/brand/product.png" height={128} />
          <IonGrid>
            <IonCol className="ion-padding">
              <IonRow>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="3">
                  <IonLabel>Device ID</IonLabel>
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="9">
                  <b>{deviceData.mac}</b>
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="3">
                  <IonLabel>HW Version</IonLabel>
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="9">
                  {JSON.stringify(deviceData?.hwVersion)}
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="3">
                  <IonLabel>SW Version</IonLabel>
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="9">
                  {JSON.stringify(deviceData?.swVersion)}
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="3">
                  <IonLabel>Geolocation</IonLabel>
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="9">
                  {"12.8148914" + ", " + "77.6932039"}
                </IonCol>
              </IonRow>
              <IonRow>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="3">
                  <IonLabel>Last Activity</IonLabel>
                </IonCol>
                <IonCol sizeXs="12" sizeSm="12" sizeMd="9">
                  {new Date(deviceData?.timeStamp).toLocaleString()}
                </IonCol>
              </IonRow>
            </IonCol>
          </IonGrid>
        </IonItem>
      </IonCard>
      {showPage === 1 ? (
        <IonGrid>
          <IonCol>
            <IonRow>
              <ImgValueComponent
                src={heartOutline}
                keyText="Status"
                value={JSON.stringify(deviceData?.currentState)}
              />
              <ImgValueComponent
                src={batteryFullOutline}
                keyText="SOC (%)"
                value={JSON.stringify(deviceData?.soc)}
              />
              <ImgValueComponent
                src={pulseOutline}
                keyText="SOH (%)"
                value={JSON.stringify(deviceData?.soh)}
              />
              <ImgValueComponent
                src={flagOutline}
                keyText="Faults"
                value={JSON.stringify(deviceData?.fault)}
              />
              <ImgValueComponent
                src={warningOutline}
                keyText="Warnings"
                value={
                  0 // TBD - to get back on decipher
                  // deviceData?.warning > 0 ? (
                  //   <IonIcon icon={warningOutline} color="warning" />
                  // ) : (
                  //   0
                  // )
                }
              />
              <ImgValueComponent
                src={pinOutline}
                keyText="Pack Voltage (V)"
                value={JSON.stringify(deviceData?.packVoltage)}
              />
              <ImgValueComponent
                src={speedometerOutline}
                keyText="Pack Current (A)"
                value={JSON.stringify(deviceData?.packCurrent / 1000)}
              />
              <ImgValueComponent
                src={timerOutline}
                keyText="Available Capacity (Ah)"
                value={JSON.stringify(deviceData?.availableCap)}
              />
            </IonRow>
          </IonCol>
          <IonRow>
            <IonCol>
              <IonCard style={{ height: "300px" }}>
                <BarChartJS
                  options={{
                    maintainAspectRatio: false,
                    responsive: true,
                  }}
                  data={packCVdata}
                />
              </IonCard>
            </IonCol>
            <IonCol>
              <IonCard style={{ height: "300px" }}>
                <BarChartJS
                  options={{
                    maintainAspectRatio: false,
                    responsive: true,
                  }}
                  data={packTempdata}
                />
              </IonCard>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : showPage === 2 ? (
        <TimeSeriesGraph mac={deviceData?.mac} />
      ) : (
        <IonCard>
          <AlarmsComponent
            code={deviceData?.warning}
            faultCode={deviceData?.fault}
          />
        </IonCard>
      )}
    </IonContent>
  );
};

export default DeviceDetails;
